import React from 'react';
import Svg from '../Svg';

const IconDroplets02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.5C12.4767 1.5 12.8871 1.83646 12.9806 2.30388C13.4326 4.56378 14.8008 6.76002 16.6247 8.21913C18.8043 9.96283 20 12.1294 20 14.5C20 16.6217 19.1571 18.6566 17.6569 20.1569C16.1566 21.6571 14.1217 22.5 12 22.5C9.87827 22.5 7.84344 21.6571 6.34315 20.1569C4.84285 18.6566 4 16.6217 4 14.5C4 12.1294 5.19568 9.96283 7.3753 8.21913C9.19919 6.76002 10.5674 4.56378 11.0194 2.30388C11.1129 1.83646 11.5233 1.5 12 1.5ZM12 5.55336C11.1944 7.19 10.0217 8.66325 8.62469 9.78087C6.80432 11.2372 6 12.8706 6 14.5C6 16.0913 6.63214 17.6174 7.75736 18.7426C8.88258 19.8679 10.4087 20.5 12 20.5C13.5913 20.5 15.1174 19.8679 16.2426 18.7426C17.3679 17.6174 18 16.0913 18 14.5C18 12.8706 17.1957 11.2372 15.3753 9.78087C13.9783 8.66325 12.8056 7.19 12 5.55336Z"
    />
  </Svg>
);

export default IconDroplets02;
